import { ExeQueue } from "./ExeQueue";
import { ComponentManager } from "./ComponentManager";
import { MediaQueriesManager } from "./MediaQueriesManager";
import { TopicManager } from "./TopicManager";
import { YouTubeMediaAdapter } from "../adapters/YouTubeMediaAdapter";
import { ScriptManager } from "../libs/adapters/script/ScriptManager";
import { ConfigModel } from "../models/ConfigModel";
import { ShareManager } from "../libs/adapters/share/ShareManager";
import { StatisticsManager } from "../libs/adapters/statistics/StatisticsManager";
import { TwitterAPIMediaAdapter } from "../adapters/TwitterAPIMediaAdapter";
import { Subscription } from "../libs/listeners/Subscription";
import { settings } from "../const/Settings";
import * as isMobile from "ismobilejs";
import { DataUtils } from "../libs/utils/DataUtils";
import { DomUtils } from "socios-tools/utils/DomUtils";
export var VPSubs;
(function (VPSubs) {
    VPSubs[VPSubs["onDocumentScrollSteps"] = 0] = "onDocumentScrollSteps";
    VPSubs[VPSubs["onWindowResizeSteps"] = 1] = "onWindowResizeSteps";
})(VPSubs || (VPSubs = {}));
class VP {
    constructor() {
        this.listener = new Subscription();
        this._localStorageKey = settings.globalPrefix + 'ls';
        this._lastScrollTop = 0;
        this._lastInnerWidth = 0;
        this._lastInnerHeight = 0;
        this.blackboard = {
            youtubeAdapter: null,
            youtubeAdsAdapter: null,
            twitterAdapter: null,
            curMediaAdapters: []
        };
        this._queue = new ExeQueue();
        this._components = new ComponentManager();
        this._mediaQueries = new MediaQueriesManager();
        this._topicManager = new TopicManager();
        this._scriptManager = new ScriptManager(document, window);
        const defaultLocalStorageData = {
            v: settings.localStorageVersion,
            history: [],
            menu: {
                current: -1,
                scroll: 0,
                opened: {}
            }
        };
        this._localStorageItem = DataUtils.getLocalStorageItem(this._localStorageKey);
        if (!this._localStorageItem.data || !this._localStorageItem.data.v || this._localStorageItem.data.v < settings.localStorageVersion) {
            log('localstorage using default');
            this._localStorageItem.data = defaultLocalStorageData;
        }
        else {
            this._localStorageItem.data = DataUtils.assignDeep(defaultLocalStorageData, this._localStorageItem.data);
        }
    }
    startDOMListeners() {
        if (!this._DOMListenersInterval) {
            this._DOMListenersInterval = setInterval(() => {
                const scrollingElement = document.scrollingElement || document.documentElement;
                if (scrollingElement.scrollTop !== this._lastScrollTop) {
                    this._lastScrollTop = scrollingElement.scrollTop;
                    this.listener.inform(VPSubs.onDocumentScrollSteps);
                }
                if (window.innerWidth !== this._lastInnerWidth) {
                    this._lastInnerWidth = window.innerWidth;
                    this.listener.inform(VPSubs.onWindowResizeSteps);
                }
                if (window.innerHeight !== this._lastInnerHeight) {
                    this._lastInnerHeight = window.innerHeight;
                    this.listener.inform(VPSubs.onWindowResizeSteps);
                }
            }, 1000);
        }
    }
    get pageTags() {
        return window['__s_pagetags'];
    }
    domReady() {
        this._config = new ConfigModel(window._config);
        this.blackboard.twitterAdapter = new TwitterAPIMediaAdapter();
        this.blackboard.youtubeAdapter = new YouTubeMediaAdapter();
        this.blackboard.youtubeAdsAdapter = this.blackboard.youtubeAdapter;
        this._shareManager = new ShareManager({
            sharing: this._config.sharingData,
            scriptManager: this._scriptManager
        });
        this._statisticsManager = new StatisticsManager({
            scriptManager: this._scriptManager,
            statistics: this._config.statisticsData
        });
    }
    isTouchDevice() {
        return isMobile.any;
    }
    userPlayedVideo(mediaModel, mediaAdapter) {
        const history = this.localStorageData.history;
        if (history.length > settings.maxMediaHistory) {
            history.shift();
        }
        const lastVideo = history[history.length - 1];
        if (!lastVideo || lastVideo.id !== mediaModel.id) {
            log('mediashistory', history.length);
            history.push({
                id: mediaModel.id,
                adap: {
                    n: mediaAdapter.shortName
                }
            });
        }
    }
    loadLazy(adsTargeting = null) {
        this._scriptManager.loadLazy();
    }
    loadImagesInView(onComplete) {
        const list = document.querySelectorAll('img[data-src]');
        function loadImage(index) {
            const img = list[index];
            if (img) {
                const src = img.getAttribute('data-src');
                if (src && DomUtils.inView(img)) {
                    setTimeout(() => {
                        img.setAttribute('src', src);
                        img.onload = () => {
                            img.classList.add('loaded');
                            img.removeAttribute('data-src');
                        };
                        loadImage(index + 1);
                    }, 10);
                }
                else {
                    loadImage(index + 1);
                }
            }
            else {
                if (onComplete) {
                    onComplete();
                }
            }
        }
        loadImage(0);
    }
    get components() {
        return this._components;
    }
    get config() {
        return this._config;
    }
    get pageType() {
        return document.body.classList[0];
    }
    get queue() {
        return this._queue;
    }
    get mediaQueries() {
        return this._mediaQueries;
    }
    get scriptManager() {
        return this._scriptManager;
    }
    get topicManager() {
        return this._topicManager;
    }
    get localStorageData() {
        return this._localStorageItem.data;
    }
    get statisticsManager() {
        return this._statisticsManager;
    }
    get shareManager() {
        return this._shareManager;
    }
}
export const vp = new VP();
